module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_s_shadow.963dd099.png";